//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { ButtonLink } from "components/styles";
//#endregion
//#region Components
import InactivityDialog from "./components/InactivityDialog/InactivityDialog";
import InactivitySummaryCard from "./components/InactivitySummaryCard/InactivitySummaryCard";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const InactivityBlock = ({
    errors,
    changeInactivity,
    duration,
    ratioMinutesTime,
    showSummaryCard = false
}) => {
    //#region States
    const [showDialog, setShowDialog] = useState(false);
    //#endregion
    //#region Functions
    const toggleShowDialog = (value = null) => {
        setShowDialog(value !== null ? value : !showDialog);
    }
    const isDateRange = () => typeof duration.date === "object";
    const verifyIsDurationCompleted = () => {
        const { date, time } = duration;
        let timeVerification = time.start > -1 && time.end > -1 && !(errors?.areInvalidTimes || errors?.time.areInvalidTimes);
        if (isDateRange()) 
            return timeVerification;
        return date > -1 && timeVerification;
    }
    const verifyAreInvalidInactivityTimes = (idx, field, value) => {
        const { start, end } = duration.time.inactivity[idx].time;
        const currentStartTime = field === "start" ? value : start;
        const currentEndTime = field === "end" ? value : end;
        return (
            currentStartTime >= 0 && 
            currentEndTime >= 0 && 
            currentStartTime >= currentEndTime 
        );
    }
    const getIntervalTimePicker = () => {
        const { time: {
            start,
            end
        } } = duration;
        return {
            min: start/60,
            max: end/60,
            exactLimits: true
        };
    }
    const areThereErrorsInInactivityTime = () => {
        return errors.time.inactivity.some(({ date, time }) => {
            return date || time.start || time.end || time.areInvalidTimes;
        });
    }
    const getClassNameForButtonInactivityDialog = () => {
        const classList = [];
        !isDurationCompleted && classList.push("disabled");
        areThereErrorsInInactivityTime() && classList.push("error");
        return classList.join(" ");
    }
    const hasInactivity = duration.time.inactivity.length > 0;
    //#endregion
    const isDurationCompleted = verifyIsDurationCompleted();
    return (
        <>
            {showSummaryCard && hasInactivity
                ? <InactivitySummaryCard
                    disabled={!isDurationCompleted}
                    hasError={areThereErrorsInInactivityTime()}
                    inactivity={duration.time.inactivity}
                    onEdit={() => setShowDialog(true)} />
                : <ButtonLink
                    className={getClassNameForButtonInactivityDialog()}
                    onClick={() => isDurationCompleted && setShowDialog(true)}>
                    Horas de inactividad
                </ButtonLink>}
            <InactivityDialog 
                show={showDialog} 
                toggleShow={toggleShowDialog} 
                inactivity={duration.time.inactivity}
                availableDay={duration.availableDay}
                errors={errors?.time.inactivity}
                verifyAreInvalidTimes={verifyAreInvalidInactivityTimes}
                ratioMinutesTime={ratioMinutesTime}
                date={duration.date}
                intervalTimePicker={getIntervalTimePicker()}
                changeInactivity={(values, errors) => {
                    changeInactivity(values, errors);
                }}/>
        </>
    );
}

export default InactivityBlock;
